import React, { useState, useEffect} from 'react';
import '../App.css';
import '../css/RecordView.css';

import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Button from '@mui/material/Button';
import Input from '@mui/material/Input';
import TextField from '@mui/material/TextField';

import Checkbox from '@mui/material/Checkbox'
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { MuiTelInput } from 'mui-tel-input'
import NotesArea from './NotesArea'
import PhoneCallsArea from './PhoneCallsArea'
import MakePhoneCall from './MakePhoneCall'
import { useSelector, useDispatch } from 'react-redux';
import { setRowData } from '../slices/dataSlice';

function PhoneField(props) {
  const dispatch = useDispatch();
  //const {records} = useSelector(state => state.data);
  //const data = props.data??{}
  const [phonenos, setPhoneNos] = useState([])
  const [dialphone, setDialPhone] = useState(null)
  const [opendialphone,setOpenDialPhone] = useState(false)
  const [phonefield,setPhoneField]=useState()
  const [donotdial,setDoNotDial]=useState(false)

  useEffect(()=> {
    props.cols.filter(item=> item.type==='phone' && item.fldSection ==='hide').map(item => {
      const number = props.data[item.field]
      if(number !== null && typeof number !== 'undefined' && number > "")
        setPhoneNos((prevPhones) => [...prevPhones, {field: item.field, type:`${item.headerName}`, number, notes: item.note, tps: false, dnc: false, nnr: false }])
      return null
    })
  },[props.time, props.cols, props.data])

  const openClickToDial = (phoneno, field) => {
    setDoNotDial(false)
    setDialPhone(phoneno)
    setOpenDialPhone(true)
    setPhoneField(field)
    dispatch(setRowData(props.data))
  }
  const openClickToAddCallNotes = (phoneno, field) => {
    setDoNotDial(true)
    setDialPhone(phoneno)
    setOpenDialPhone(true)
    setPhoneField(field)
    dispatch(setRowData(props.data))
  }
  const closeClickToDial = () => {
    setDialPhone("")
    setOpenDialPhone(false)
    setPhoneField(null)
  
  }



  const formatPhone = (phonein) => {
    if(typeof phonein === "undefined" || phonein === null)
      return "";
    let phone = (phonein??"").replaceAll(" ", "")
    if(phone==="") return "";
    if(phone.substr(0,1) === "0")
      return `+44${phone.substr(1)}`
    return `+44${phone}`;
  }

    let phonectrls =  <></>;
    if(typeof phonenos !== "undefined" && typeof props.field !== 'undefined' && Array.isArray(phonenos)) {
      phonectrls = phonenos.map((phitem,index) =>
        <div  key={`phnflddiv_${props.uid}_${index}` } className='fielddivider'>
          <div className='muiphonecontainer' key={`phnfldtel_${props.uid}_${index}` } >
            <MuiTelInput
              style={{fontSize: '10pt!important'}}
              defaultCountry="GB"
              label={`Phone ${index+1}`}
              id={`phone_${props.uid}_${index}`}
              name={phitem.field}
              type='tel'
              value={formatPhone(phitem.number??'')}
              variant="standard"
              readOnly={true}
              inputProps={{style: {fontSize: '10pt', width: '700px'}}}
            />
          </div>
          <div className='pnhoptdiv' key={`phntypediv_${props.uid}_${index}` } >
            <select id={`phonetype_${props.uid}_${index}`} value={phitem.type} style={{fontSize: '10pt',marginRight: '5px'}}  disabled>
              <option value="" >Select</option>
              <option value='CC Main Phone' disabled>CC Lead Main Number</option>
              <option value='CC Alt Phone' disabled >CC Lead Alt Number</option>
              <option value='CC Mobile' disabled >CC Lead Mobile Number</option>
              <option value='Home'>Home</option>
              <option value='Office'>Office</option>
              <option value='Mobile'>Personal Mobile</option>
              <option value='WorkMobile'>Work Mobile</option>
              <option value='PA'>PA / Assitant</option>
              <option value='Accountant'>Accountant</option>

            </select><br/>
            <div className="phnoptpouts" key={`phnfldpopts_${props.uid}_${index}` }  >
              <input id={`chktps_${props.uid}_${index}`} type='checkbox' checked={phitem.tps??false} className='chephncheckbox'  disabled /><label  className="checkboxlabels" for={`chktps_${props.uid}_${index}`} >TPS&nbsp;&nbsp;</label>
              <input id={`chknnr_${props.uid}_${index}`} type='checkbox' checked={phitem.nnr??false} className='chephncheckbox'  disabled    /><label  className='checkboxlabels' for={`chknnr_${props.uid}_${index}`} >NNR&nbsp;&nbsp;</label>
              <input id={`chkdnc_${phitem.uid}_${index}`} type='checkbox' checked={phitem.dnc??false} className='chephncheckbox'  disabled  /><label  className='checkboxlabels' for={`chkdnc_${props.uid}_${index}}`} >DNC</label>
            </div>
          </div>
          <div style={{display: 'inline-block', width: '450px', fontSize: '10pt', verticalAlign: 'top'}}  key={`phnfldnotes_${props.uid}_${index}` }  >
              Notes: <textarea className='phnnotes' row={2} cols={30} disabled defaultValue={phitem.notes}></textarea>
          </div>
          <div style={{display: 'inline-block', width:'320px'}} >
            <Button variant="outlined" size="small" className='btn_dial' onClick={() => openClickToDial(formatPhone(phitem.number??''), phitem.field) }>
                Click To Dial
            </Button>&nbsp;
            <Button variant="outlined" size="small" className='btn_dial' onClick={() => openClickToAddCallNotes(formatPhone(phitem.number??''), phitem.field) }>
                Add Call Notes
            </Button>
          </div>
        </div>
      )
    }
    return (
      <React.Fragment>
        <MakePhoneCall open={opendialphone} phone={dialphone} field={phonefield} data={props.data??null} onClose={closeClickToDial} donotdial={donotdial} />
        {phonectrls}
      </React.Fragment>)
}


function RecordView(props) {
  const [open, setOpen] = React.useState(false);
  const [data,setData]=useState(props.data)
  const auth = useSelector(state => state.auth)

  useEffect(()=> {
    async function LoadData() {
      // We used to use this for Loading Notes
    }
    if(!open) {
      console.log(`RecordEdit props.open set to ${props.open}`)
      setOpen(props.open)
      setData(props.data)
    }
    if(props.open && auth.token > "" && typeof props.data !== 'undefined' && props.data.id > "" )
      LoadData();
  },[props.open, props.data, auth.token, open]);



  const addTextField = (item, index) => {
    return (
      <div className='fielddivider' key={`txtfld_${index}_${Date.now()}`} >
            <TextField
              label={item.headerName}
              id={item.field}
              name={item.field}
              type='text'
              defaultValue={(typeof item.valueGetter==='undefined')?data[item.field]??'':item.valueGetter(data[item.field]??'') }
              disabled
              variant="standard"
              inputProps={{style: {input:{"::disabled":{ color: '#004AAC'}}, fontSize: '10pt', width: '500px'}}}
              readOnly={true}
              size='small'
            />
      </div>

    )
  }
  const addDateField = (item, index) => {
    return (
      <div key={`datefld_${(item.field??"").replaceAll(" ","").toLowerCase()}` } className='fielddivider'  >
      <InputLabel shrink={true} htmlFor={item.field} sx={{backgroundColor: 'white'}}>{item.headerName}&nbsp;</InputLabel>
      <Input
        label={item.headerName}
        id={item.field}
        name={item.field}
        type='date'
        defaultValue={data[item.field]??''}
        disabled
        variant="standard"
        sx={{fontSize: '10pt'}}
        readOnly={true}
      />
      </div>
    )
  }

  const updatePhoneData = (field, newdata) => {
    setData((prevData)=> (
        {...prevData,[field]: newdata}
      )
    )
  }

  const addPhoneField = (item, index) => {
    return (
      <PhoneField key={`phonefld_${index}_${Date.now()}`} time={Date.now()} cols={props.cols} data={data} field={item} uid={1} updateParent={updatePhoneData} />
    )
  }

  const addSelectField = (item, index) => {
    return (
      <div  key={`fld_${(item.field??"").replaceAll(" ","").toLowerCase()}_${index}_${Date.now()}` }  className='fielddivider' >

      <FormControl style={{ width: "100%", marginTop: 10, marginBottom: 5 }} size="small">
        <InputLabel shrink={true} htmlFor={item.field} sx={{backgroundColor: 'white'}}>{item.headerName}&nbsp;</InputLabel>
        <Select
          style={{ width: "90%"}}
          label={`lbl_${item.field}`}
          id={item.field}
          name={item.field}
          defaultValue={(data[item.field]??'').toUpperCase()}
          displayEmpty
          disabled
          readOnly={true}
        >
          {item.valueOptions.map((itema, index) => {
            return (
              <MenuItem disabled key={`${item.field}_${index}`} value={itema.value} >
                {itema.label}
              </MenuItem>
              )
          })}
        </Select>
      </FormControl>
      </div>
    )
  }
  const addCheckBoxField = (item,index) => {
    return (
      <div  key={`chkfld_${(item.field??"").replaceAll(" ","").toLowerCase()}_${index}_${Date.now()}` }  className='fielddivider' >

      <FormControlLabel
      label={item.headerName}
      control={<Checkbox
        /*sx ={{
            "& MuiFormControlLabel-root .MuiFormControlLabel-label.Mui-disabled": {
                      WebkitTextFillColor: "#004AAC",
            }
        }}*/
        id={item.field} checked={data[item.field]??false} readOnly={true} disabled />}
      />
      </div>
    )
  }

  const viewDirectors = (item) => {
    let dirs = []
    let showHTML = true;
    try {
      const dr = JSON.parse(data[item.field])
      for(const item of dr)
        dirs.push(item.toLowerCase().replace(/\b\w/g, s => s.toUpperCase()))
    }catch(err) {
      showHTML = false;
    }
    const text = dirs.join(", ")

    const html = (<><h4 style={{textAlign: 'left', marginBottom: 0, paddingBottom: '5px', padding: 0, marginTop: '5px'}}>Active Director / Offices</h4>
                    <ul style={{paddingTop: '10px', marginTop: 0}}>
                    {dirs.map((item,index) => (<li key={`directorli_${index}_${Date.now()}`} style={{fontSize: '10pt', verticalAlign: 'top',height: '24px!important', lineHeight: '20px!important'}}>{item}</li>))}
                    </ul>
                  </>
                  )
    if(showHTML)
        return html;
    return text;
  }

  const chooseConrol = (item, index) => {
    //console.log(`chooseControl => ${(item.type??'').toLowerCase()}`)
    if(item.field === "Directors")
      return viewDirectors(item, index);

    switch((item.type??'').toLowerCase()) {
      case 'phone':
        return addPhoneField(item,index)
      case 'string':
        return addTextField(item,index)
      case 'date':
        return addDateField(item,index)
      case 'boolean':
        return addCheckBoxField(item,index)
      case 'singleselect':
        return addSelectField(item,index)
      default:
        return addTextField(item,index);
    }

  }

  return (
    <div className='container' >
        <h4>View Lead</h4>
        <div id='content' className='content' key='recordview_content' >
            <strong>Company Details</strong><br/>
            {props.cols.filter((item,index)=>item.fldSection==='company').map((item,index) => {
              return chooseConrol(item, index)
            })}
            <strong>Contact Details</strong><br/>
            {props.cols.filter(item=>item.fldSection==='contact' && (typeof item.isphone == 'undefined' || !item.isphone) ).map((item,index) => {
              return chooseConrol(item, index)
            })}
            <strong>Phone Numbers</strong><br/>
            {props.cols.filter(item=>item.isphone ||item.fldSection==='phone').map((item, index) => {
              let phitem = {...item,isphone: true, type: 'phone' }
              return addPhoneField(phitem, index);
            })}

            <br/><strong>Lead Details</strong>
            {props.cols.filter(item=>item.fldSection==='data').map((item, index) => {
              return chooseConrol(item, index)
            })}
            <br/><strong>Information / Status</strong>
            {props.cols.filter(item=>item.fldSection==='status').map((item, index) => {
              return chooseConrol(item, index)
            })}
        </div>
        <NotesArea key={`notearea_1}` }  accordion={true} data={data} id={data?.id} />
        <PhoneCallsArea key={`notearea_1` } accordion={true}  data={data??null} refresh={Date.now()}/>
      </div>
  );
}

export default RecordView